import { Popover } from '@mui/material';
import { defineds } from '../../constants/ui.constants';
import { useAppSelector } from '../../hooks/redux.hooks';
import { DateRangePicker, createStaticRanges, Calendar } from 'react-date-range';
import { getMobile } from '../../state/reducers/ui.reducers';
import { CustomDateRangePicker } from '../../theme/elements/Inputs';
import React, { useState, useEffect } from 'react';

interface Props {
	id: any;
	showCalender: boolean;
	anchorEl: any;
	value: any;
	handleClose: any;
	onChange: any;
}

export default function CalendarPopover(props: Props) {
	const isMobile = useAppSelector(getMobile);

	return (
		<Popover
			id={props.id}
			open={props.showCalender}
			anchorEl={props.anchorEl}
			onClose={props.handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
		>
			<CustomDateRangePicker>
				<Calendar
					onChange={(item) => {
						props.onChange(item);
					}}
					date={props.value}
					direction={isMobile ? 'vertical' : 'horizontal'}
				/>
			</CustomDateRangePicker>
		</Popover>
	);
}
